import { Form } from "antd"
import { Checkbox, Icon, Text } from "components/common"
import { t } from "i18next"
import { useAddSalesContext } from "features/leads/components/addSalesModal/addSalesContext/addSalesContext"
import { configs } from "configs"

const BuyerFeeCheckbox = ({ listFieldName, disabled = false }) => {
  const { vasEnabled } = useAddSalesContext()
  const visible = vasEnabled && configs.showBuyerFeeCheckbox
  if (!visible) return null

  return (
    <Form.Item preserve name={[listFieldName, "buyerFee"]} valuePropName="checked" initialValue={false}>
      <Checkbox disabled={disabled}>
        <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
          <Text className="gray-900">{t("Mark as Bayut Service Fee")}</Text>
          <Icon
            hasBackground
            icon="BsInfo"
            color="#707070"
            size="16px"
            style={{
              backgroundColor: "#E6E6E6",
              borderRadius: "1rem",
              margin: -8,
            }}
            className="pointer"
            tooltipText={t("This indicates the fee was received directly in Bayut's bank account.")}
          />
        </span>
      </Checkbox>
    </Form.Item>
  )
}

export default BuyerFeeCheckbox
